/**
 * Обработчик вызовов методов
 * @type {Object}
 */
var Applier = {
    /**
     * Метод вызывает переданный метод с аргументами у элементов массива context.related
     * @param {*[]} contextsArray
     * @param {string} method
     * @param {Array} [args]
     */
    applyToContextsArray: function (contextsArray, method, args) {
        if (contextsArray instanceof Array) {
            contextsArray.forEach(
                function (context) {
                    this.applyTo(context, method, args);
                },
                this
            );
        }
    },
    /**
     * Метод вызывает переданный метод с аргументами в переданном контексте
     * @param {*} context
     * @param {string} method
     * @param {Array} [args]
     */
    applyTo(context, method, args){
        if (context[method]) {
            context[method].apply(context, args);
        }
    }
};

module.exports = Applier;



// WEBPACK FOOTER //
// ./assets/javascript/interactive_parameters/module/Applier.js